import {
  FETCH_PATIENTUSERDETAILS_SUCCESS_ACTION,
  FETCH_PATIENTDETAILSVIEW_SUCCESS_ACTION,
  FETCH_PATIENTDETAILSVIEW_INIT_ACTION,
  FETCH_PATIENTPRESCRIPTIONVIEW_SUCCESS_ACTION,
  FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PATIENTUSERDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        patientuserDtlsList: action.payload.rows,
        patientuserDtlsCount: action.payload.count
      };

    case FETCH_PATIENTDETAILSVIEW_SUCCESS_ACTION:
      return {
        ...state,
        patientsmainDtls: action.payload
      };

    case FETCH_PATIENTDETAILSVIEW_INIT_ACTION:
      return {
        ...state,
        patientsmainDtls: {}
      };

    case FETCH_PATIENTPRESCRIPTIONVIEW_SUCCESS_ACTION:
      return {
        ...state,
        patientsprscrptnls: action.payload.rows,
        patientsprscrptnlsCount: action.payload.count
      };

    case FETCH_PATIENTPRESCRIPTIONVIEW_INIT_ACTION:
      return {
        ...state,
        patientsprscrptnDtls: {}
      };

    default:
      return {
        ...state
      };
  }
}
